<script>
    export let data;
    export let superseded_elements = false;
</script>
<style>

</style>

{#if data > 0 && !superseded_elements}
    <span class="badge badge-pill badge-primary">{data}</span>
{:else if data > 0 && superseded_elements}
    <span class="badge badge-pill badge-secondary">{data}</span>
{:else if !superseded_elements}
    <span class="badge badge-pill badge-secondary">{data}</span>
{/if}
